import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

import { ShellComponent } from './shell.component';

@NgModule({
  imports: [CommonModule, TranslateModule, RouterModule],
  declarations: [ShellComponent]
})
export class ShellModule {}
